import {
  REPORT_A_ISSUE,
} from "app/utils/constants/paths";
import jwtAuthAxios from "./auth/jwtAuth";

const reportService = {};

reportService.createReport = async (report) => {
  try {
    const { data } = await jwtAuthAxios.post(REPORT_A_ISSUE, report);
    return data;
  } catch (error) {
    throw error;
  }
};

export default reportService;



